import React, { FC } from 'react';
import DOMPurify from 'dompurify';
import { Icon } from 'kl-b2c-ui-kit';
import { useTranslation } from 'react-i18next';

import { UserBio } from 'types';

import { BottomContent, ContentCard, Description, Flip, Follow, Name, Text } from './styled';

export const UserBioBack: FC<UserBio> = ({ description, name, twitter }) => {
    const { t } = useTranslation('pages/home');

    return (
        <ContentCard>
            <Text>
                <Name>{name}</Name>

                <Description
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(description),
                    }}
                />

                <BottomContent>
                    {twitter && (
                        <Follow>
                            {t('follow')}{' '}
                            <a
                                href={`https://x.com/${twitter}`}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(event) => event.stopPropagation()}
                            >
                                @{twitter}
                            </a>
                        </Follow>
                    )}

                    {(twitter || description) && (
                        <Flip>
                            <span>{t('flip-less')}</span>
                            <Icon name="Refresh" size={18} color="teal" />
                        </Flip>
                    )}
                </BottomContent>
            </Text>
        </ContentCard>
    );
};
